import React from "react";
import "./style.scss";
import ICLoader from "./img/ic-loader.svg";
import ICLoaderBorder from "./img/ic-loader-c.svg";

export default function Loader({ show, blackBg, small, className }) {
  return (
    <div
      className={`ic-loader ${show ? "show" : ""} ${
        blackBg ? "black-bg" : ""
      } ${small ? "small" : ""} ${className ? className : ""}`}
    >
      <div className="ic-loader-bg"></div>
      <div className="ic-loader-border"></div>
      <img className="ic-loader-i" src={ICLoader} alt="i" />
    </div>
  );
}
